'use strict';
import React from 'react';
import { Link } from 'react-router';
/**
 * A link to be used in breadcrumbs.
 *
 * @extends {React.Component}
 * @property {String} href link address
 */
class PageHeaderNavigationLink extends React.Component {
  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { children, linkTo, ...otherProps } = this.props;
    return (
      <Link {...otherProps} className="PageHeader-navigationLink" to={linkTo}>{children}</Link>
    );
  }
}

export default PageHeaderNavigationLink;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/pageHeader/pageHeaderNavigationLink.jsx